import { schema } from 'normalizr';

export const document = new schema.Entity('documents');
export const documents = [document];
